import SectionHeader from "./SectionHeader";

const PRINCIPLES = [
  {
    icon: "ri-focus-3-line",
    title: "聚合聚焦",
    desc: "把散落在各处的本月大瓜爆点、猛料、头条与焦点统一收拢，按热度与话题集中呈现。",
  },
  {
    icon: "ri-verified-badge-line",
    title: "核实为先",
    desc: "整理内容以公开可查证信息与官方回应为准，对仍待证实的信息会明确标注状态。",
  },
  {
    icon: "ri-time-line",
    title: "实时跟进",
    desc: "热榜按热度实时刷新，话题与时间线随事件进展分批更新，绝不让你错过关键节点。",
  },
  {
    icon: "ri-user-heart-line",
    title: "理性吃瓜",
    desc: "倡导对事不对人、对号入座式的理性讨论，尊重当事人与各方观点，不散播未经证实的定论。",
  },
];

export default function About() {
  return (
    <section id="about" className="bg-background-100 py-14 md:py-20">
      <SectionHeader
        eyebrow="关于本站"
        title="本站是什么，本站主张什么"
        desc="本月大瓜是一份面向所有追热点用户的「热点速览日报」，我们用更结构化的方式整理本月大瓜爆点与焦点，让围观这件事更高效、更清楚。"
        accent
      />

      <div className="mx-auto mt-10 grid w-full max-w-7xl grid-cols-1 gap-8 px-4 md:px-6 lg:grid-cols-5">
        <div className="rounded-2xl border border-background-200 bg-background-50 p-8 lg:col-span-2">
          <p className="flex items-center gap-2 text-xs font-bold tracking-widest text-accent-700 uppercase">
            <i className="ri-newspaper-line" /> 我们的态度
          </p>
          <p className="font-heading mt-4 text-2xl leading-snug font-black text-foreground-950">
            不是制造瓜，
            <br />
            而是帮你
            <span className="text-primary-600">看清瓜、跟上瓜</span>。
          </p>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            在这个信息又快又杂的时代，我们希望做你手机里那个「打开就知道今天在聊什么」的入口。用榜单、话题与时间线，把本月大瓜拆成清晰的一块块，让每个人都能轻松补课、理性参与。
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <a
              href="#breaking"
              className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition hover:bg-primary-600"
            >
              去看今日爆点 <i className="ri-arrow-right-line" />
            </a>
            <a
              href="#timeline"
              className="inline-flex items-center gap-1 whitespace-nowrap rounded-full border border-background-300 bg-background-100 px-5 py-2.5 text-sm font-semibold text-foreground-900 transition hover:border-accent-400 hover:text-accent-700"
            >
              补课时间线
            </a>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:col-span-3">
          {PRINCIPLES.map((p) => (
            <article
              key={p.title}
              className="rounded-2xl border border-background-200 bg-background-50 p-6 transition hover:border-accent-300"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary-50 text-xl text-primary-600">
                <i className={p.icon} />
              </span>
              <h3 className="font-heading mt-4 text-base font-bold text-foreground-950">{p.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{p.desc}</p>
            </article>
          ))}
        </div>
      </div>

      <div className="mx-auto mt-8 max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-3 rounded-2xl border border-accent-200 bg-accent-50 p-6 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <h3 className="font-heading text-base font-bold text-accent-900">想反馈或投稿线索？欢迎联系</h3>
            <p className="mt-1 text-sm text-accent-800">
              本站信息以公开来源为准并持续更新，如有错误欢迎指正，我们会在核实后尽快更正。
            </p>
          </div>
          <a
            href="mailto:contact@bengyueguo.example"
            className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-full bg-accent-500 px-5 py-2.5 text-sm font-semibold text-foreground-950 transition hover:bg-accent-600"
          >
            <i className="ri-mail-send-fill" /> contact@bengyueguo.example
          </a>
        </div>
      </div>
    </section>
  );
}